import '../scss/app.scss';

require('./common.js');

require('slick-carousel');
require('./slick-slider.js');
require('./gallerySlider.js');
require('./animation_keyvisual-headline.js');
require('./animation_ap-site.js');
require('./animation_accordion.js');
require('./menu-button-links.js');
//require('./accessible-tabs.js');
require('./main.js');